export { AccessPage as default } from '@/components/pages/Company/Access'
